export function extractMessageBodyText(messageBody) {
  if (typeof messageBody === "string") return messageBody;

  if (messageBody && typeof messageBody.message === "string") {
    return messageBody.message;
  }

  return "";
}

export function resolveDisplayedChatText({
  messageBody,
  translatedText,
  onDemandTranslation,
  shouldShowTranslation,
  showOnDemandOverride
}) {
  const originalText = extractMessageBodyText(messageBody);

  if (showOnDemandOverride && onDemandTranslation?.text) {
    return onDemandTranslation.text;
  }

  if (shouldShowTranslation && translatedText) {
    return translatedText;
  }

  return originalText;
}
